import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Role } from '../../../api/app-types/role.app';
import { ROLE_SERVICE } from '../../../api/services/role.service';
import { PaginatedResponse } from '../../pagination/paginated-response';

export const rolesResolver: ResolveFn<PaginatedResponse<Role>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(ROLE_SERVICE);
	const response = await api.getAll();
	return response;
};
